import types from 'constants/ConstructionConstants';
import Immutable from 'immutable';

const initialState = Immutable.fromJS({
	constructionList: Immutable.List(),
});

export default function(state = initialState, action) {
	switch (action.type) {
		case types.RESET_CONSTRUCTION_LIST:
			return state.set('constructionList', Immutable.fromJS(action.constructionList));
		
		case types.ADD_CONSTRUCTION:
			return state.updateIn(['constructionList'], list => list.push(Immutable.fromJS({
        cid: action.cid,
				name: action.name,
				year: action.year,
				status: 0,
				assignTo: action.assignTo,
				cost: 0
      })))

		case types.DELETE_CONSTRUCTION:
			return state.deleteIn(['constructionList', state.get('constructionList').findIndex((construction) => construction.get('cid') === action.cid)])

		case types.UPDATE_CONSTRUCTION:
			let id = state.get('constructionList').findIndex(construction => construction.get('cid') === action.cid);
			return state.setIn(['constructionList', id, 'name'], action.name)
									.setIn(['constructionList', id, 'year'], action.year)
									.setIn(['constructionList', id, 'status'], action.status)
									.setIn(['constructionList', id, 'assignTo'], action.assignTo)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/Construction.js